import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// eslint-disable-next-line import/no-extraneous-dependencies
import { styled } from "@mui/system"; // @mui/system is maybe a dependency of @mui/material, can't install separately
import useConfirm from "hooks/use-confirm";
// import { useMaterialUIController } from "context";

// { theme } can be added into the argument of function of second round braces to use theme ex: styled(...)(({theme}) => (...))
const ThemedDialog = styled(({ children, ...props }) => <Dialog {...props}>{children}</Dialog>)(
  () => ({
    "& .MuiDialog-container .MuiPaper-root": {
      padding: "20px 20px 0 20px",
      backgroundColor: "#333",
    },
  })
);

export default function ConfirmAlert() {
  // const themeContext = useMaterialUIController();
  // const isDarkmode = themeContext[0].darkMode;

  const {
    isOpen = false,
    proceed,
    cancel,
    approveText,
    rejectText,
    title = "",
    description = "",
  } = useConfirm();

  return (
    <ThemedDialog
      open={isOpen}
      onClose={cancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        style={{
          color: "#fff",
        }}
        id="alert-dialog-title"
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          style={{
            color: "#aaa",
          }}
          id="alert-dialog-description"
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>{rejectText}</Button>
        <Button onClick={proceed} autoFocus>
          {approveText}
        </Button>
      </DialogActions>
    </ThemedDialog>
  );
}

// import * as React from "react";
// import { styled } from "@mui/material/styles";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Switch from "@mui/material/Switch";
// import Stack from "@mui/material/Stack";
// import Typography from "@mui/material/Typography";

// const IOSSwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 42,
//   height: 26,
//   padding: 0,
//   "& .MuiSwitch-switchBase": {
//     padding: 0,
//     margin: 2,
//     transitionDuration: "300ms",
//     "&.Mui-checked": {
//       transform: "translateX(16px)",
//       color: "#fff",
//       "& + .MuiSwitch-track": {
//         backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
//         opacity: 1,
//         border: 0,
//       },
//       "&.Mui-disabled + .MuiSwitch-track": {
//         opacity: 0.5,
//       },
//     },
//     "&.Mui-focusVisible .MuiSwitch-thumb": {
//       color: "#33cf4d",
//       border: "6px solid #fff",
//     },
//     "&.Mui-disabled .MuiSwitch-thumb": {
//       color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
//     },
//     "&.Mui-disabled + .MuiSwitch-track": {
//       opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     boxSizing: "border-box",
//     width: 22,
//     height: 22,
//   },
//   "& .MuiSwitch-track": {
//     borderRadius: 26 / 2,
//     backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
//     opacity: 1,
//     transition: theme.transitions.create(["background-color"], {
//       duration: 500,
//     }),
//     height: "26px",
//     width: "52px"
//   },
// }));

// export default function StyledSwitch(props) {
//   const { label, checked, onChange } = props;
//   return (
//     <FormGroup>
//       <FormControlLabel
//         control={<IOSSwitch onClick={() => onChange(!checked)} checked={checked} sx={{ m: 1 }} />}
//         label={label}
//       />
//     </FormGroup>
//   );
// }
